import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { ArrowBack, FileCopyOutlined, ArrowUpward } from '@mui/icons-material';

const HeaderLinks = ({ onClickClose, questionnaireId, onDuplicate, onNewVersion }) => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.Questionnaire.BackToList')} onClick={onClickClose}>
        <ArrowBack />
      </IconButton>
      {questionnaireId && (
        <>
          <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.Duplicate')} onClick={onDuplicate}>
            <FileCopyOutlined color='primary' />
          </IconButton>

          <IconButton fontSize='medium' color='transparent' tooltip={t('Tooltips.NewVersion')} onClick={onNewVersion}>
            <ArrowUpward color='primary' />
          </IconButton>
        </>
      )}
    </>
  );
};

HeaderLinks.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  questionnaireId: PropTypes.number,
  onDuplicate: PropTypes.func.isRequired,
  onNewVersion: PropTypes.func.isRequired
};

export default HeaderLinks;
